import React, { Component } from "react";
import './Face.css';
import Cookies from "js-cookie";
import * as actions from '../Actions';
import { fetchInitialData2 } from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';
import withContext from "../../../withContext";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useNavigate } from "react-router-dom";

const service = new Service();

class Face extends Component {
  constructor(props) {
    super(props);
    let initialData = {};
    let getBanner = [];
    let FaceData = [];
    let childList = global.userAry['childData']?.UserChildList || [];

    if (__isBrowser__ && window.__initialData__ && window.__initialData__["initialData"] ) {
      initialData = window.__initialData__["initialData"];

        if (initialData['data1'] && initialData['data1']['result']) {
            getBanner = initialData['data1']['result'];
        }
        if (initialData['data2'] && initialData['data2']['result']) {
            FaceData = initialData['data2']['result'];
        }
      delete window.__initialData__;
    } else {
      if (
        props.staticContext &&
        props.staticContext.initialData &&
        props.staticContext.initialData["initialData"]
      ) {
        initialData = props.staticContext.initialData["initialData"];
        if (initialData['data1'] && initialData['data1']['result']) {
            getBanner = initialData['data1']['result'];

        }
        if (initialData['data2'] && initialData['data2']['result']) {
            FaceData = initialData['data2']['result'];
        }
      }
    }

    this.state = {
        initialData: initialData||{},
        getBanner: getBanner||[],
        FaceData: FaceData||[],
        childListData: childList||[],
        yearData:[],
        monthAry : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        shortMonth: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        currentDate:new Date(),
        frameDate:'',
        selectchildName:'',
        selectedChild:'',
        ChildDob:'',
        childPhoto:'',
        IsExpected: false
    };
  }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var selectedChild='';
        if (childData && childData['UserChildList'] && childData['UserChildList'].length > 0) {
            if (childData['UserChildList'].length== 1 && childData['UserChildList'][0].IsExpected) {
                selectedChild = 0;
            } else {
                if(!childData['UserChildList'][0].IsExpected){
                    selectedChild = parseInt(childData['UserChildList'][0].ChildId);
                }else{
                selectedChild = parseInt(childData['UserChildList'][1].ChildId);
                }
            } 
        } else {
            selectedChild = 0
        }
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let obj1 = {
            url: global.api_url + "config/getdfpbannerdata",
            body: JSON.stringify({
                "moduleId": "5"
            })
        };
        let obj2 = {
            url: global.api_url + "face/getfacedata",
            body: JSON.stringify({
                "childId":selectedChild,
                "month":(new Date().getMonth() + 1),
                "year":(new Date().getFullYear()),
                "pagesize":"31",
                "pageno":1,
            })
        };
        return fetchInitialData2(obj1, obj2, JSON.stringify(header));
    }

    componentDidMount() {

        var qUrl = global.currentURL;
        var contestId;
        if (qUrl.includes('?')) {
            contestId = qUrl.split('?')[1];
            this.setState({ contestId: contestId });
            console.log('<<<<<< contestId >>>>>>>> ',contestId);
        }
        document.addEventListener("click", this.domClick);

        if (global.userAry['IsExpected']) {
            this.setState({ IsExpected: true });
        } else {
            this.setState({ IsExpected: false });
        }

        if (this.state.childListData) {
            if (this.state.childListData.length > 1) {
                if (this.state.childListData[0]['IsExpected']) {
                    this.state.selectchildName = this.state.childListData[1]['ChildName'];
                    this.state.selectedChild = this.state.childListData[1]['ChildId'];
                    this.state.childPhoto=this.state.childListData[1]['childPhoto'];
                    this.state.ChildDob=this.state.childListData[1]['DOB'].replace(/-/g, ' ');
                } else {
                    this.state.selectchildName = this.state.childListData[0]['ChildName'];
                    this.state.selectedChild = this.state.childListData[0]['ChildId'];
                    this.state.childPhoto=this.state.childListData[0]['childPhoto'];
                    this.state.ChildDob=this.state.childListData[0]['DOB'].replace(/-/g, ' ');
                }
            } else if (this.state.childListData.length == 1) {
                if (this.state.childListData[0]['IsExpected']) {
                    this.state.selectchildName = '';
                    this.state.selectedChild = '';
                    this.state.childPhoto='';

                } else {
                    this.state.selectchildName = this.state.childListData[0]['ChildName'];
                    this.state.selectedChild = this.state.childListData[0]['ChildId'];
                    this.state.childPhoto=this.state.childListData[0]['childPhoto'];
                    this.state.ChildDob=this.state.childListData[0]['DOB'].replace(/-/g, ' ');
                }
            } else {
                this.state.selectchildName = '';
                this.state.selectedChild = '';
                this.state.childPhoto='';
            }
        }

        if (navigator.onLine) {
            if (!this.state.FaceData || (this.state.FaceData && Object.keys(this.state.FaceData).length < 1)) {

                const dob = this.state.ChildDob;
                const dateObj = new Date(dob);

                const month = dateObj.getMonth() + 1; // (0–11) so +1
                const year = dateObj.getFullYear();

                service.showLoader();
                this.getFaceData(this.state.selectedChild);
            } else {
                localStorage.setItem('FaceData', JSON.stringify(this.state.FaceData));
                this.OnloadData(this.state.selectedChild);
            }
            if (!this.state.getBanner || (this.state.getBanner && this.state.getBanner.length < 1)) {
                service.showLoader();
                this.getBannerData();
            } else {
                localStorage.setItem('getBanner', JSON.stringify(this.state.getBanner));
            }
            service.hideLoader();
        }else {
            if (localStorage.getItem('FaceData')) {
                this.setState({ FaceData: JSON.parse(localStorage.getItem('FaceData'))}, () => { this.OnloadData(this.state.selectedChild); 
                });
            }
            if (localStorage.getItem('getBanner')) {
                this.setState({
                    getBanner: JSON.parse(localStorage.getItem('getBanner'))
                });
            }
            service.hideLoader();
            
        }

    }

    getFaceData(selectedChild,sMonth,sYear) {
        var pagesize='31';
        var month,year;
        if (parseInt(sMonth) == 0) {
            pagesize=366;
        } else {
            pagesize=31;
        }
        if(sYear && sMonth){
            year=sYear;
            month=sMonth;
        }else{
            month=(new Date().getMonth() + 1);
            year=(new Date().getFullYear());
        }
        var postData={
                "childId":selectedChild,
                "month":month,
                "year":year,
                "pagesize":pagesize,
                "pageno":1,
            };
            // var url= global.api_url + "face/getfacedata";
            var url = global.api_ci_url + "api/fetchfromCI/face~getfacedata";
            
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                this.setState({
                    FaceData: json['result'],
                }, () => { this.OnloadData(this.state.selectedChild,sMonth,sYear); });
                localStorage.setItem('FaceData', JSON.stringify(json));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    getBannerData(){
        var postData={
            "moduleId": "5"
        }
        var url = global.api_ci_url + "api/fetchfromCI/config~getdfpbannerdata";
        // var url= global.api_url + "config/getdfpbannerdata"; config/getdfpbannerdata
        // const url = global.api_ci_url + "api/fetchfromCI/duedate~getduedatedetails_v1";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                this.setState({
                    getBanner: json['result']
                }, () => {  });
                localStorage.setItem('getBanner', JSON.stringify(json));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    
    OnloadData(selectedChild,sMonth,sYear) {
        this.loadYrDropdown(selectedChild,sMonth,sYear);
        if (window.innerWidth < 767) {
            document.querySelector('.frame_face').width=((window.innerWidth - 33) / 2);
        }
        this.loadMsiteClasses();
        let frames= document.querySelectorAll(".upload_href");
        for(var i=0;i<frames.length;i++){
            var fDateAry = frames[i].getAttribute('data-date').split('-');
            var month=new Date(frames[i].getAttribute('data-date')).getMonth();
            var fDate = new Date(parseInt(fDateAry[2]), parseInt(month), parseInt(fDateAry[0]));
            if (fDate.getFullYear() == this.state.currentDate.getFullYear() && fDate.getMonth() == this.state.currentDate.getMonth() && fDate.getDate() > this.state.currentDate.getDate()) {
                frames[i].classList.add('half_opacity');
            }else{
                if(frames[i].classList.contains('half_opacity')){
                    frames[i].classList.remove('half_opacity');
                }
            }
        }
    }
    loadYrDropdown(selectedChild,sMonth,sYear){
        var mntVal = this.state.currentDate.getMonth() + 1;
        var MntYear = this.state.currentDate.getFullYear();
        if (mntVal < 10) {
            mntVal = "0" + mntVal
        }

        let yearData1=[];
        if (global.ftk) {
            if (this.state.childListData && this.state.childListData.length > 0) {
                for (var i = this.state.currentDate.getFullYear(); i > (new Date(this.state.ChildDob).getFullYear() - 1); i--) {
                    // this.state.yearData[i]=i;
                    yearData1.push(i);
                }
            } else {
                yearData1.push(MntYear);
            }
            this.setState({yearData:yearData1});
           
            setTimeout(() => {
            if(sMonth && sYear){
                document.querySelector("#face_month").value=(sMonth);
                document.querySelector("#old_month").value=(sMonth);
                document.querySelector("#face_year").value=(sYear);
                document.querySelector("#old_year").value=(sYear);
                }else{
                    document.querySelector('#face_year').value=MntYear;
                    document.querySelector('#face_month').value=mntVal;
                    document.querySelector('#old_month').value=mntVal;
                    document.querySelector('#old_year').value=MntYear;
                }
               
                let mark=document.querySelectorAll(".children");
                for(var i=0;i<mark.length;i++){
                    mark[i].lastChild.style.visibility="hidden";
                    mark[i].style.background="";
                }
                if(this.state.selectedChild!=''){
                    document.querySelector("#id_"+this.state.selectedChild).lastChild.style.visibility="visible";
                    document.querySelector("#id_"+this.state.selectedChild).style.background="#f5f5f5";
                }
            }, 50);

        } else {
            yearData1.push(MntYear);
            this.setState({yearData:yearData1});
            console.log("mntVal=======> yearData",this.state.yearData);
            document.querySelector("#face_year").disabled = true;
            document.querySelector("#face_month").disabled = true;
            if(sMonth && sYear){
                document.querySelector("#face_month").value=(sMonth);
                document.querySelector("#old_month").value=(sMonth);
                document.querySelector("#face_year").value=(sYear);
                document.querySelector("#old_year").value=(sYear);
                }else{
                    document.querySelector('#face_year').value=this.state.currentDate.getFullYear();
                    document.querySelector('#face_month').value=mntVal;
                    document.querySelector('#old_month').value=mntVal;
                    document.querySelector('#old_year').value=this.state.currentDate.getFullYear();
            }
        }
        if (window.innerWidth < 767) {
            document.querySelector('.face_month_dropdown').width=((window.innerWidth - 35) / 2);
            document.querySelector('.face_year_dropdown').width=((window.innerWidth - 35) / 2);
        }
        Cookies.set("ChildName",this.state.selectchildName);
    }
    loadMsiteClasses() {
        console.log("loadMsiteClasses======>");
        if (window.innerWidth < 767) {
            // document.querySelector('.frame_face').find('.R14_9e').addClass('R12_9E');
            // document.querySelector('.frame_face').find('.R12_9E').removeClass('R14_9e');
            // document.querySelector('.frame_face').find('.R15_42').addClass('R8_42');
            // document.querySelector('.frame_face').find('.R8_42').removeClass('R15_42');
            // document.querySelector('.frame_face').find('.B15_pink').addClass('B9_pink');
            // document.querySelector('.frame_face').find('.B9_pink').removeClass('B15_pink');
            actions.removeSelfClass("R14_9e","R12_9E");
            actions.removeSelfClass("R12_9E","R14_9e");
            actions.removeSelfClass("R15_42","R8_42");
            actions.removeSelfClass("R8_42","R15_42");
            actions.removeSelfClass("B15_pink","B9_pink");
            actions.removeSelfClass("B9_pink","B15_pink");
          
            if (window.innerWidth < 350) {
                // document.querySelector('.frame_face').find('.M13_white').addClass('M9_white');
                // document.querySelector('.frame_face').find('.M9_white').removeClass('M13_white');
                actions.removeSelfClass("M13_white","M9_white");
                actions.removeSelfClass("M9_white","M13_white");
            } else if (window.innerWidth < 430) {
                // document.querySelector('.frame_face').find('.M13_white').addClass('M10_white');
                // document.querySelector('.frame_face').find('.M10_white').removeClass('M13_white');
                actions.removeSelfClass("M13_white","M10_white");
                actions.removeSelfClass("M10_white","M13_white");
            } else if (window.innerWidth < 510) { } else {
                // document.querySelector('.frame_face').find('.M13_white').addClass('M15_white');
                // document.querySelector('.frame_face').find('.M15_white').removeClass('M13_white');
                actions.removeSelfClass("M13_white","M15_white");
                actions.removeSelfClass("M15_white","M13_white");
            }
            if (window.innerWidth < 360) {
                // document.querySelector('.photo_wrapper').find('.M30_white').addClass('M20_white');
                // document.querySelector('.photo_wrapper').find('.M20_white').removeClass('M30_white');
                // actions.removeSelfClass("M30_white","M20_white");
                // actions.removeSelfClass("M20_white","M30_white");
            } else if (window.innerWidth < 464) {
                // document.querySelector('.photo_wrapper').find('.M30_white').addClass('M23_white');
                // document.querySelector('.photo_wrapper').find('.M23_white').removeClass('M30_white');
                // actions.removeSelfClass("M30_white","M23_white");
                // actions.removeSelfClass("M23_white","M30_white");
            }
            // document.querySelector('.photo_wrapper').find('.R32_42').addClass('R26_42');
            // document.querySelector('.photo_wrapper').find('.R26_42').removeClass('R32_42');
            // document.querySelector('.photo_wrapper').find('.B43_pink').addClass('B30_pink');
            // document.querySelector('.photo_wrapper').find('.B30_pink').removeClass('B43_pink');
            // document.querySelector('.photo_wrapper').find('.R28_9e').addClass('R20_9e');
            // document.querySelector('.photo_wrapper').find('.R20_9e').removeClass('R28_9e');
                // document.querySelector('#childDropdown').find('.M24_pink').addClass('M15_pink');
                // document.querySelector('#childDropdown').find('.M15_pink').removeClass('M24_pink');
            actions.removeSelfClass("M24_pink","M15_pink");
            actions.removeSelfClass("M15_pink","M24_pink");
            // document.querySelector('.face_banner').find('.R17_75').addClass('R13_75');
            // document.querySelector('.face_banner').find('.R13_75').removeClass('R17_75');
            // document.querySelector('.video-container').find('.R17_75').addClass('R15_75');
            // document.querySelector('.video-container').find('.R15_75').removeClass('R17_75');
            // document.querySelector('.face_star').find('.M15_pink').addClass('M13_pink');
            // document.querySelector('.face_star').find('.M13_pink').removeClass('M15_pink');
            // document.querySelector('.face_star').find('.M15_61').addClass('M13_61');
            // document.querySelector('.face_star').find('.M13_61').removeClass('M15_61');

        }
    }
    uploadPage(e){
        if (!global.ftk) {
            document.querySelector(".alertmsg").innerHTML=("Please login");
            document.querySelector('.alertMsg-overlay').style.display="block";
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;  
            return false;
        }else{
            var fDateAry = e.target.parentNode.getAttribute('data-date').split('-');
            var month=new Date(e.target.parentNode.getAttribute('data-date')).getMonth();
            var fDate = new Date(parseInt(fDateAry[2]), parseInt(month), parseInt(fDateAry[0]));
            
            if (fDate.getFullYear() == this.state.currentDate.getFullYear() && fDate.getMonth() == this.state.currentDate.getMonth() && fDate.getDate() > this.state.currentDate.getDate()) {
                alert("Please wait till “" + fDate.getDate() + " " + this.state.monthAry[(fDate.getMonth())] + " " + fDate.getFullYear() + "” to upload your most memorable baby’s picture.")
            } else {
                Cookies.set("faceFrameId", e.target.parentNode.getAttribute('data-id'));
                Cookies.set("faceFrameUrl", e.target.parentNode.getAttribute('data-url'));
                Cookies.set("faceDate", e.target.parentNode.getAttribute('data-date'));
                Cookies.set("faceDay", e.target.parentNode.getAttribute('data-day'));
                // Cookies.set("ChildName",this.state.selectchildName);
                if (!global.userAry['userName']) {
                    console.log('-----------------1');
                    document.querySelector(".alertmsg").innerHTML=("Please complete your profile!");
                    document.querySelector(".alert-popup").css=("left", '1%');
                    document.querySelector('.alertMsg-overlay').style.display="block";
                    window.location.href = service.getRedirectUrl('/my-account/myprofile?URL=' + global.currentURL);
                    // this.props.history.push(service.getRedirectUrl('/my-account/myprofile?URL=' + global.currentURL));
                    return false;
                } else if (!this.state.childListData || this.state.childListData.length < 1 || (this.state.childListData && this.state.childListData.length == 1 && this.state.childListData[0].IsExpected)) {
                    document.querySelector(".alertmsg").innerHTML=("Please add child details to upload Face a Day Memories.");
                    document.querySelector('.alertMsg-overlay').style.display="block";
                    document.querySelector(".alert-popup").css=("left", '1%');
                    window.location.href = service.getRedirectUrl('/my-account/myprofile?URL=' + global.currentURL);
                    // this.props.history.push(service.getRedirectUrl('/my-account/myprofile?URL=' + global.currentURL));
                } else {
                    var face_page = global.currentURL.split("&");
                    if (!face_page[1]) {
                        if(this.state.contestId){
                            this.props.navigate(service.getRedirectUrl('/tools/capture-baby-moments/uploadfaces?'+this.state.contestId));
                        }else{
                            // this.props.navigate(service.getRedirectUrl('/tools/capture-baby-moments/uploadfaces'));
                            window.location.href = service.getRedirectUrl('/tools/capture-baby-moments/uploadfaces');  
                        }
                    } else {
                        this.props.navigate(service.getRedirectUrl('/tools/capture-baby-moments/uploadfaces?' + face_page[1]));
                    }
                }
            }
        }
    }
    childrenlist() {
        console.log("childrenlist==================>");
        if (document.getElementById("myDropdown").style.display == "block") {
            document.getElementById("myDropdown").style.display = "none";
        } else {
            document.getElementById("myDropdown").style.display = "block"
        }
        if (document.getElementById("myDropdown").style.display == "block") {
            console.log("window.innerWidth=====>",window.innerWidth)
            if (window.innerWidth < 767) {
                document.querySelector('.drop-down').classList.add('dropdown_overlay');
                document.querySelector("#myDropdown").parentNode.classList.remove('mydropdown_overlay');
                // document.querySelector('.card_container').css=("overflow", "hidden");
                var dropdown_height = window.innerHeight - document.querySelector('#myDropdown').offsetTop + document.querySelector('#myDropdown').offsetHeight;
                document.querySelector('.mydropdown_overlay').style.height=dropdown_height;
                document.querySelector('body').style.overflow="hidden";
            }
        } else {
            if (window.innerWidth < 767) {
                document.querySelector('.drop-down').classList.remove('dropdown_overlay');
                document.querySelector('.mydropdown_overlay').style.height=0;
                document.querySelector("#myDropdown").parentNode.classList.remove('mydropdown_overlay');
                // document.querySelector('.card_container').css("overflow-y", "scroll");
                document.querySelector('body').style.overflow="visible";

            }
        }
    }
    selectChild(childId,chnm,DOB,childPhoto) {
        this.state.ChildDob=DOB;
        this.state.selectedChild=childId;
        this.state.selectchildName=chnm;
        this.state.childPhoto=childPhoto;
        console.log("childSelect================>",chnm);
        service.showLoader();

        var mntVal = this.state.currentDate.getMonth() + 1;
        if (mntVal < 10) {
            mntVal = "0" + mntVal
        }
        document.querySelector('#face_year').value=(this.state.currentDate.getFullYear());
        document.querySelector('#face_month').value=(mntVal);
        var sMonth = document.querySelector("#face_month").value;
        var sYear = document.querySelector("#face_year").value;
        document.querySelector('#myDropdown').style.display="none";
        this.getFaceData(childId, sMonth, sYear, chnm);
    }
    CheckMonthYear(ischeck){
        console.log("ischeck==============>",ischeck);
        var sMonth = document.querySelector("#face_month").value;
        var sYear = document.querySelector("#face_year").value;
        console.log("sYear=========>",sYear);
        var selectedChild = 0;
        if (this.state.selectedChild) {
            selectedChild = this.state.selectedChild;
        }
        console.log("selectedChild============>",this.state.selectedChild);
        var childDOB = "";
        if (selectedChild > 0 && this.state.childListData && this.state.childListData.length > 0) {
            for (var i = 0; i < this.state.childListData.length; i++) {
                if (this.state.childListData[i].ChildId == selectedChild) {
                    childDOB = this.state.childListData[i].DOB
                }
            }
        }
        if (childDOB != "") {
            childDOB = new Date(childDOB.replace(/-/g, ' '));
            childDOB.setDate(1)
        }
        if(ischeck=="year"){
            if (sYear == this.state.currentDate.getFullYear()) {
                console.log("sYear=========>1",sYear);
                var mVal = this.state.currentDate.getMonth() + 1;
                mVal = mVal < 10 ? "0" + mVal : mVal;
                document.querySelector("#face_month").value=mVal;
            } else if (childDOB && sYear == childDOB.getFullYear()) {
                var mVal = childDOB.getMonth() + 1;
                mVal = mVal < 10 ? "0" + mVal : mVal;
                document.querySelector("#face_month").value=(mVal)
            }
            sMonth = document.querySelector("#face_month").value;
            sYear = document.querySelector("#face_year").value;
        }
        console.log("childDOB====>",childDOB);
        console.log("this.state.ChildDob ======>",this.state.ChildDob);
        var selDate = new Date(parseInt(sYear), parseInt(sMonth) - 1, 1);
        if (sYear == this.state.currentDate.getFullYear() && sMonth > (this.state.currentDate.getMonth() + 1)) {
            document.querySelector('.date_err').innerHTML=("You can't select future month and year.");
            document.querySelector('.date_err').style.display="block";
            document.querySelector("#face_month").value=(document.querySelector('#old_month').value);
            document.querySelector("#face_year").value=(document.querySelector('#old_year').value)
        } else if (sMonth != "00" && childDOB != "" && selDate < childDOB) {
            document.querySelector('.date_err').innerHTML=("Please select month and year after Child DOB");
            document.querySelector('.date_err').style.display="block";
            document.querySelector("#face_month").value=(document.querySelector('#old_month').value);
            document.querySelector("#face_year").value=(document.querySelector('#old_year').value)
        } else {
            document.querySelector('.date_err').style.display="none";
            console.log("sYear=========>2",sYear);
            this.getFaceData(selectedChild, sMonth, sYear);
        }
        if(ischeck=='month'){
            console.log("viewSlideShow==================>");
            var childId = this.state.selectedChild;
            if (sMonth) {
                var month = sMonth;
            } else {
                var month = "";
            }
            var postData={
                "childId":childId,
                "month":month,
                "year":sYear
            };
            
            var url = global.api_ci_url + "api/fetchfromCI/faceaday~faceADayVideo";
            service.postServiceCall(url, postData).then((json) => {
            console.log("faceADayVideo==============>",json);
            if (json['result']) {
                this.setState({
                
                }, () => {});
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    }
    setFrameDate(frameDate){
        var d=frameDate.split("-");
        var splitDate=d[0]+"-"+this.state.shortMonth[parseInt(d[1]-1)]+"-"+d[2];
        // var D=new Date(splitDate).toString().split(" ");
        this.state.frameDate=splitDate;
        return this.state.frameDate;
    }
    viewSlideShow(){
        if (!global.ftk) {
            document.querySelector(".alertmsg").innerHTML=("Please login");
            document.querySelector('.alertMsg-overlay').style.display="block";
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;  
            return false;
        }else{
            this.CheckMonthYear("month");
            var sMonth = this.state.shortMonth[parseInt(document.querySelector("#face_month").value) - 1];
            var sYear = document.querySelector("#face_year").value;
            Cookies.set("slideShowMon", sMonth, 1);
            Cookies.set("slideMonth", document.querySelector("#face_month").value, 1);
            Cookies.set("slideShowYr", sYear, 1);
            window.location.href = service.getRedirectUrl("/tools/capture-baby-moments/slide-show");
        }
    }
    domClick(event) {
        console.log("domClick==================================>", event.target.parentNode.parentNode);
        if (document.querySelector("#myDropdown").style.display=="block" && !event.target.parentNode.parentNode.classList.contains("selected-child")) {
            document.querySelector("#myDropdown").style.display="none";
        }else {
            return false;
        }
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.domClick);  
    }

  render() {
   
    return (
            <main className="main-container Face">
                <Helmet
                    title="Capture Your Baby Bump Week by Week - FirstCry Parenting"
                    meta={[
                        { "name": "Preserving baby memories is one of the best ways to save the precious moments of your baby so that you can’t miss out those lovely & funny moments of your child’s first year. With capture baby moments tool this is made easy. Picture today." },
                        {"name":"keywords","content":"capturing baby moments, picturing baby moments"},{ "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Baby Moments</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Face a Day</h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left Face">
                        {global.ftk && this.state.selectchildName ? (
                            <div id="childDropdown">
                                    <div className="drop-down">
                                        <div className="selected-child" onClick={() => { this.childrenlist() }}>
                                            <div className="M24_pink">
                                            <span className="childPic">
                                            {this.state.childPhoto != "" ?
                                                (<img src={this.state.childPhoto} 
                                                    onError={(e) => {
                                                        e.target.src = "https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png";
                                                    }}
                                                    className="devimgpik"/>
                                                ):
                                                (<img src="https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png" className="devimgpik"/>
                                                )
                                            }
                                            </span>
                                            <div className="diet-title">Face a Day of {this.state.selectchildName}</div>
                                            {(global.userAry['childData']['UserChildList'].length) > 2 || ((global.userAry['childData']['UserChildList'].length == 2) && !this.state.IsExpected) ? (<span data-icon-font="f" className="M24_pink dropbtn right" ></span>) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="dropdown">
                                        <div id="myDropdown" className="dropdown-content" style={{ display: "none" }}>
                                            {this.state.childListData && this.state.childListData.length > 0 && this.state.childListData.map(result =>
                                                !result.IsExpected ?
                                                (
                                                    <div  key={result.ChildId} className="children" id={"id_"+result.ChildId} onClick={() => { this.selectChild(result.ChildId,result.ChildName,result.DOB,result.childPhoto) }}>
                                                        {(result.childPhoto != "") ?
                                                            (<span className="childPic">
                                                                <img src={result.childPhoto} alt="" title="" 
                                                                onError={(e) => {
                                                                    e.target.src = "https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png";
                                                                }} className="devimgpik"/>
                                                            </span>) : (
                                                                <span className="childPic">
                                                                    <img src="https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png" alt="" title="" className="devimgpik"/>
                                                                </span>)
                                                        }
                                                        <span className="child_name R16_42">{result.ChildName}</span>
                                                        <span className="current_child right" data-icon-font=";" style={{ visibility: "hidden" }}></span>
                                                    </div>
                                                ) : null
                                            )
                                            }

                                        </div>
                                    </div>
                                    </div>
                                ) : null
                                }   
                        <div className="face_container">
                            <div className="face_dropdown_container">
                                <div className="face_year_dropdown">
                                <input type="hidden" id="old_year"/>
                                    <select name="month" className="face_year" id="face_year" dadat-id={this.state.yearData[1]} onClick={(e)=>{this.CheckMonthYear('year')}}>
                                    {
                                        this.state.yearData && this.state.yearData.length > 0 && this.state.yearData.map(result=>
                                            <option key={result}  value={result}>{result}</option>
                                        )
                                    }
                                    </select>
                                    <span className="icon arrow-icon" data-icon-font="f"></span>
                                </div>
                                <div className="face_month_dropdown">
                                    <input type="hidden" id="old_month"/>
                                        <select name="month" className="face_month" id="face_month" onClick={(e)=>{this.CheckMonthYear('month')}}>
                                            <option value="01">January</option>
                                            <option value="02">February</option>
                                            <option value="03">March</option>
                                            <option value="04">April</option>
                                            <option value="05">May</option>
                                            <option value="06">June</option>
                                            <option value="07">July</option>
                                            <option value="08">August</option>
                                            <option value="09">September</option>
                                            <option value="10">October</option>
                                            <option value="11">November</option>
                                            <option value="12">December</option>
                                            <option value="00">All</option>
                                        </select>
                                    <span className="icon arrow-icon" data-icon-font="f"></span>
                                </div>
                                <div className="date_err"></div>
                            </div>
                            <div className="face_list">
                            {Array.isArray(this.state.FaceData) && this.state.FaceData.length > 0 && this.state.FaceData.map((frameList, index) => 
                                <li key={index} className="frame_face">
                                    {frameList.isFaceUploaded ?
                                        (<img src={frameList.frameImage} className="devimagframe"/> )
                                        :(
                                        <div>
                                        <a className="upload_href" data-id={frameList.frameId} data-url={frameList.dayImageUrl} data-day={frameList.DayOfMonth} data-date={this.setFrameDate(frameList.frameDate)} target="_self" onClick={(e)=>{this.uploadPage(e)}}>
                                            <img src={frameList.dayImageUrl} className="devimagframe" alt={`Face a Day - Day ${frameList.DayOfMonth} Frame`} title={`Face a Day - Day ${frameList.DayOfMonth} Frame`}/>
                                            <span className="R14_9e add_photo" data-id={frameList.frameId} data-url={frameList.dayImageUrl} data-day={frameList.DayOfMonth} data-date={this.state.frameDate}>
                                                <span data-icon-font="x" className="icon"></span>
                                                Add Photo
                                            </span>
                                        </a>
                                        <span className="M13_white face_date_container">
                                            {this.state.frameDate}
                                        </span>
                                        </div>
                                    )}
                                </li>
                            )}
                        </div>
                        {/* if (!global.ftk) */}
                        {global.ftk && (
                            <div className="viewslide_btns"> 
                                <span className="askB_1 view_btn" id="view_btn" onClick={()=>{this.viewSlideShow()}}>
                                    <span className="B14_white" id="dev_SlidBtn">
                                        <span data-icon-font="&#xe060;" className="icon">
                                            </span> View Slideshow</span>
                                </span>
                            </div>
                        )}
                        </div>
                    </div>
                </div>                
                <Right url={this.props.location.pathname} />
            </main>
    )

  }
}
export default withContext(Face);